import { Action } from '../../actions';
import { StoreState } from '../../reducers';
import { Dispatch } from 'react-redux';

export enum NoSaveAsPopupActionKeys {
	CLOSE = '@@NoSaveAsPopup/CLOSE',
	OPEN = '@@NoSaveAsPopup/OPEN',
}

export type NoSaveAsPopupAction = CloseAction | OpenAction;

interface CloseAction extends Action {
	type: NoSaveAsPopupActionKeys.CLOSE;
}

interface OpenAction extends Action {
	type: NoSaveAsPopupActionKeys.OPEN;
}

const closeNoSaveAsPopup = () =>
	(dispatch: Dispatch<StoreState>): void => {
		const action: NoSaveAsPopupAction = {
			type: NoSaveAsPopupActionKeys.CLOSE,
		};
		dispatch(action);
	};

const openNoSaveAsPopup = () =>
	(dispatch: Dispatch<StoreState>): void => {
		const action: NoSaveAsPopupAction = {
			type: NoSaveAsPopupActionKeys.OPEN,
		};
		dispatch(action);
	};

export {
	closeNoSaveAsPopup,
	openNoSaveAsPopup,
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/NoSaveAsPopup/actions.ts